import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import { mapIconContainerSizes, mapSizes } from "./constants.js";
const StyledSegmentedControl = styled("div")(() => ({
  display: "flex",
  flexDirection: "row"
})), StyledIconContainer = styled("div")(({ size = "md" }) => {
  const iconContainerSize = mapIconContainerSizes[size];
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: iconContainerSize,
    height: iconContainerSize,
    svg: {
      width: size === "sm" || size === "xs" ? "13px" : "17px",
      height: size === "sm" || size === "xs" ? "14px" : "18px"
    }
  };
}), StyledButton = styled(
  "button",
  shouldNotForwardProps(["isActive", "isIcon", "variant", "size"])
)(({
  theme,
  isActive,
  isIcon,
  variant = "solid",
  size = "md"
}) => {
  const state = isActive ? "selected" : "unselected", palette = theme.palette.segment[variant][state], sizes = mapSizes[size];
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: sizes.height,
    padding: sizes.padding,
    color: palette.content.default,
    backgroundColor: palette.bg.default,
    border: "unset",
    outline: "1px solid",
    outlineColor: "border" in palette ? palette.border.default : palette.bg.default,
    ...isActive && variant === "outlined" && {
      outline: "2px solid",
      outlineOffset: "-1px"
    },
    ...isActive && {
      zIndex: 2
    },
    ...isIcon && {
      width: sizes.width,
      padding: 0
    },
    "&:first-of-type": {
      borderTopLeftRadius: "2px",
      borderBottomLeftRadius: "2px"
    },
    "&:last-of-type": {
      borderTopRightRadius: "2px",
      borderBottomRightRadius: "2px"
    },
    "@media(hover:hover)": {
      "&:hover": {
        cursor: "pointer",
        zIndex: 1,
        outlineColor: "border" in palette ? palette.border.hover : palette.bg.hover,
        color: palette.content.hover,
        backgroundColor: palette.bg.hover
      }
    },
    "&:disabled": {
      cursor: "default",
      pointerEvents: "none",
      outlineColor: "border" in palette ? palette.border.disabled : palette.bg.disabled,
      color: palette.content.disabled,
      backgroundColor: palette.bg.disabled
    }
  };
});
export {
  StyledButton,
  StyledIconContainer,
  StyledSegmentedControl
};
//# sourceMappingURL=styles.js.map
